import {svgIconWrapper} from '../svg-icon-wrapper';

import PeopleRoofRegular from './people-roof-regular-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PeopleRoofRegular {...validProps} />;
}

SvgComponent.iconName = 'peopleRoofRegular';

export const PeopleRoofRegularIcon = svgIconWrapper(SvgComponent);
